module.exports = __webpack_public_path__ + "img/Logo-1.cb83aeed.svg";